document.addEventListener("DOMContentLoaded", () => {
    const searchOverlay = document.querySelector(".search-overlay");
    const searchContainer = document.querySelector(".search-container");
    const searchIcon = document.getElementById("search-icon-custom");
    const searchClose = document.querySelector(".search-close");
    const searchInput = document.getElementById("search-input");
    const clearText = document.getElementById("clear-text");
    const didYouMean = document.getElementById("did-you-mean");
    const emptyState = document.getElementById("empty-state");
    const searchResults = document.getElementById("search-results");

    // Open search popup
    searchIcon.addEventListener("click", () => {
        searchOverlay.classList.add("active");
        document.body.classList.add("no-scroll"); // Prevent scrolling
        document.documentElement.classList.add("no-scroll");
        searchInput.focus();
        searchContainer.style.transform = "translateY(0)";
        searchContainer.style.opacity = "1";
    });

    // Close search popup
    searchClose.addEventListener("click", () => {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("no-scroll");
        document.documentElement.classList.remove("no-scroll");
    });

    // Clear text field
    clearText.addEventListener("click", () => {
        searchInput.value = "";
        searchInput.focus();
        updateSearchState();
    });

    // Handle input changes with debounce
    let debounceTimer;
    searchInput.addEventListener("input", () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(updateSearchState, 200);
    });

    function updateSearchState() {
        const query = searchInput.value.trim();
        const hasText = query !== "" && query.length >= 3;

        clearText.style.display = hasText ? "block" : "none";
        // didYouMean.innerHTML = hasText ? `<strong>Did you mean?</strong> <a href="#" class="btn-link-hover">${query}</a>` : "";
        // emptyState.style.display = hasText ? "none" : "block";
        // searchResults.style.display = hasText ? "block" : "none";
    }
});
